exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-select-menu .md-menu-content-bottom-start .md-menu-content-small .md-menu-content {\r\n  max-height: 50vh;\r\n  max-width: 90%;\n}\n.autocomplete-result{\r\n    white-space: normal; \r\n    max-height:5em; \r\n    overflow:hidden;\n}\n.standards-list-item {\r\n  border-left: 5px solid #ff5252;\r\n  list-style-type: none;\r\n  margin: 10px;\r\n  padding-left: 10px;\n}\n.standards-list {\r\n  list-style-type: none;\n}\np.collapsed {\r\n  display: none;\n}\nli.collapsed {\r\n  display:inline-block;\n}\r\n", ""]);

// exports
